export const isDateAfterOrderDate = (formDate: number, orderDate: number): boolean => {
  return formDate >= orderDate
}

export const isAfterToday = (formDate: number): boolean => {
  const today = new Date().setHours(23, 59, 59, 999)
  return formDate > today
}
